import { useSession } from "../../../SessionContext";
import { ScreenSequence } from "../Sequences";
import { UltimatumScreen1 } from "./UltimatumScreen1";
import { UltimatumScreen2 } from "./UltimatumScreen2";
import { WellDoneScreen } from "../../../WellDoneScreen";
import { UltimatumResultScreen } from "./ResultScreen";
import { ExplanationScreen } from "./ExplanationScreen";
import { ResultScreenGlobal } from "./ResultScreenGlobal";
import { useLanguage } from "../../../../context/LanguageContext";

export const UltimatumKey = "Ultimatum";

export function useUltimatumSequence(): ScreenSequence {
    const { userData } = useSession();
    const { t } = useLanguage();

    const randomizer3 = userData?.randomizer3 ?? "Bedingung 1";

    return {
        name: t('experiments', 'ultimatum', 'title'),
        description: t('experiments', 'ultimatum', 'description'),
        group: "A2",
        screens: [
            randomizer3 === "Bedingung 2"
                ? { component: UltimatumScreen2 }
                : { component: UltimatumScreen1 },
            { component: UltimatumResultScreen.component },
            { component: ResultScreenGlobal.component },
            { component: ExplanationScreen.component },
            {
                component: WellDoneScreen,
                canContinueDefault: false,
            }
        ],
        resultScreenIndex: 1,
        explanationScreenIndex: 3, // now the explanation is after global
    };
}